import { lazy, Suspense, FC } from 'react';
import { useSelector } from 'react-redux';

import { SHOW_SHOP_LOCAL_TOAST } from './shopLocalConstants';
import { NotificationsReducerState } from '../notificationsReducer';

const ShopLocalToast = lazy(
    () =>
        import(
            /* webpackChunkName: "ShopLocalToast" */
            './components/ShopLocalToast'
        )
);

type ReduxState = { notificationsReducer: NotificationsReducerState };

export const ShopLocalNotificationLoader: FC = () => {
    const notifications = useSelector(
        (state: ReduxState) => state.notificationsReducer?.notifications || {}
    );
    if (notifications[SHOW_SHOP_LOCAL_TOAST]) {
        return (
            <Suspense fallback="">
                <ShopLocalToast />
            </Suspense>
        );
    }
    return null;
};
